import { render, staticRenderFns } from "./RirekishoShortPreview.vue?vue&type=template&id=9c92d64e&"
import script from "./RirekishoShortPreview.vue?vue&type=script&lang=js&"
export * from "./RirekishoShortPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports